module.exports = __webpack_public_path__ + "static/SLFC-finalBook-bdce8d1b1dfb0921fea8ae6cb7f7d1e5.jpg";